import {
    SET_ACTIVE_ORDER,
    CHANGE_ITEM_QUANTITY,
    SET_SHOULD_RELOAD_DATA,
    SET_STORE_COMMENT,
    SET_DIRTY,
	UPDATE_TOTALS,
    SHOW_DIRTY_MODAL,
    SET_WEB_ORDER_COUPON,
    SET_STORE_HAS_COUPONS,
    SET_HAS_ALREADY_COUPON,
    SHOW_LOGIN_SIGNUP_MODAL
} from "../../actions/actionTypes";

export function storeOrderStatusReducer(state, action) {
	state = state || {};
	switch (action.type) {
		case SET_ACTIVE_ORDER:
			const activeOrder = action.activeOrder||{};
			return Object.assign({}, state, {
				activeOrder: activeOrder.items,
				isChanged: false,
				currentOrder: activeOrder.items,
				orderKey: activeOrder.orderKey,
                message: activeOrder.message,
				comments: activeOrder.comments,
                coupon: activeOrder.coupon,
				shouldReloadData: action.shouldReloadData,
                usedFarmigoCredits: activeOrder.usedFarmigoCredits
			});
		case CHANGE_ITEM_QUANTITY: {
            let current = Object.assign({}, state.currentOrder || {});
            if (action.newQuantity <= 0) {
                delete current[action.key];
            } else {
                current[action.key] = Object.assign({}, current[action.key] || {key: action.key}, {quantity: action.newQuantity});
            }
            let active = Object.assign({}, (state.activeOrder || {}));
            let changed = false;
            for (let p in current) {
                if (!current.hasOwnProperty(p)) {
                    continue;
                }
                let aVal = active[p];
                if (!aVal) {
                    // this is new item in current order
                    changed = true;
                    break;
                }
                let cVal = current[p];
                if (aVal.quantity !== cVal.quantity) {
                    // item quantity was changed
                    changed = true;
                    break;
                }
                delete active[p];
            }
            changed = changed || Object.keys(active).length > 0;
            return Object.assign({}, state, {isChanged: changed, currentOrder: current});
        }
        case SET_SHOULD_RELOAD_DATA:
            return Object.assign({}, state, {
                shouldReloadData: action.shouldReloadData
            });
        case SET_STORE_COMMENT:
            return Object.assign({}, state, {
                comments: action.comments
            });
		case SET_DIRTY:
			return Object.assign({}, state, {isChanged: action.dirty});
        case UPDATE_TOTALS:
            return Object.assign({}, state, {totals: action.totals, orderedItems: action.orderedItems});
        case SHOW_DIRTY_MODAL:
            const showModal = action.show ? {onLeaveCallBack: action.onLeaveCallBack} : undefined;
            return Object.assign({}, state, {showModal});
        case SET_STORE_HAS_COUPONS: {
            return Object.assign({}, state, {
                hasCoupons: action.hasCoupons
            });
        }
        case SET_WEB_ORDER_COUPON:
            return Object.assign({}, state, {coupon: action.coupon});
        case SET_HAS_ALREADY_COUPON:
            return Object.assign({}, state, {hasAlreadyCoupon: action.hasAlreadyCoupon});
        case SHOW_LOGIN_SIGNUP_MODAL:
            return Object.assign({}, state, {showLoginSignupModal: action.show});
        default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/store/storeOrderStatusReducer.js